import { zUid } from "src/types/zUid";
import { z } from "zod";

export const zMc2SizeRec = z.object({
  position: z.number(),
  value: z.number(),
});
export type ZMc2SizeRec = z.infer<typeof zMc2SizeRec>;

export const zMc2TableRow = z.object({
  id: zUid,
  mcEntityV2Id: zUid,
  point: z.string(),
  dictionaryPointId: zUid.nullish(),
  fromDictionary: z.boolean(), // похоже на лишнее
  description: z.string().nullable(),
  criticality: z.boolean(),
  scaleMinus: z.number().nullable(),
  scalePlus: z.number().nullable(),
  tolMinus: z.number().nullable(),
  tolPlus: z.number().nullable(),
  sizes: z.record(z.string(), zMc2SizeRec),
  position: z.number().nullish(),
});

export type ZMc2TableRow = z.infer<typeof zMc2TableRow>;

export const zMc2TableResponse = z.object({
  header: z.string().array(),
  rows: zMc2TableRow.array(),
});
export type ZMc2TableResponse = z.infer<typeof zMc2TableResponse>;

export const emptyTableResponse: ZMc2TableResponse = {
  header: [],
  rows: [],
};

export type Mc2MapPoint = {
  nameFrom: string;
  nameTo: string;
  baseSize: boolean;
};
